import { environment } from '../../environments/environment';

export const Global = {
  SECURITY_BASE_API_URL: environment.securityApiUrl,
};
